import type { EcExport } from "../api/resources";

/**
 * What Enterprise Context did with an observation we proposed. This is a SECOND badge, next to
 * the human-confirmation badge, on purpose: "Human confirmed" (a person here agreed this is what
 * they said) and "Published" (an Enterprise Context administrator made it official) are two
 * different decisions by two different people in two different systems.
 */
const TONE: Record<EcExport["governance_state"], string> = {
  "Not submitted": "neutral",
  Submitted: "open",
  "Under review": "open",
  Approved: "accent",
  Published: "verified",
  Rejected: "danger",
  Superseded: "neutral",
};

const HINT: Record<EcExport["governance_state"], string> = {
  "Not submitted": "Not proposed to Enterprise Context (yet, or by design).",
  Submitted: "Proposed to Enterprise Context; a steward has not reviewed it.",
  "Under review": "An Enterprise Context steward is reviewing it.",
  Approved: "A steward approved it. Not official until an administrator publishes.",
  Published: "Official Enterprise Context. Resolves authoritatively.",
  Rejected: "A steward rejected it.",
  Superseded: "A newer statement replaced it.",
};

export function GovernanceBadge({ export: row }: { export: EcExport | undefined }) {
  const state = row?.governance_state ?? "Not submitted";
  const title = [HINT[state], row?.decision_reason ? `Steward: ${row.decision_reason}` : null]
    .filter(Boolean)
    .join(" ");
  return (
    <span className={`badge badge--${TONE[state]}`} title={title} data-testid="governance-badge">
      Enterprise Context: {state}
    </span>
  );
}
